import type { VModelEvents } from '../hooks/use-v-model';
import { createEmits } from '../utils/emits';
import type { TabBarIndex } from './tab-bar';

interface Events extends VModelEvents<TabBarIndex> {
}

const {
  defineEmitType,
  useEmits,
} = createEmits<Events>();

export {
  useEmits,
};

export const emits = defineEmitType([
  'input',
  'update:modelValue',
]);
